/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUmpImportResultDto
 */
export interface GetUmpImportResultDto {
    /**
     * 
     * @type {number}
     * @memberof GetUmpImportResultDto
     */
    okCount: number;
    /**
     * 
     * @type {number}
     * @memberof GetUmpImportResultDto
     */
    errorCount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUmpImportResultDto
     */
    messages: Array<string>;
}

/**
 * Check if a given object implements the GetUmpImportResultDto interface.
 */
export function instanceOfGetUmpImportResultDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "okCount" in value;
    isInstance = isInstance && "errorCount" in value;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function GetUmpImportResultDtoFromJSON(json: any): GetUmpImportResultDto {
    return GetUmpImportResultDtoFromJSONTyped(json, false);
}

export function GetUmpImportResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUmpImportResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'okCount': json['okCount'],
        'errorCount': json['errorCount'],
        'messages': json['messages'],
    };
}

export function GetUmpImportResultDtoToJSON(value?: GetUmpImportResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'okCount': value.okCount,
        'errorCount': value.errorCount,
        'messages': value.messages,
    };
}

